import { render, staticRenderFns } from "./StudentClassCalendarComponent.vue?vue&type=template&id=43a762d1&"
import script from "./StudentClassCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./StudentClassCalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./StudentClassCalendarComponent.vue?vue&type=style&index=0&id=43a762d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports